import { KTCard } from '../../../../../../_metronic/helpers'
import { header, header_one, header_three, header_two } from './_columns'
import { useState } from 'react'
import { useAuth } from '../../../../auth'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import {
  QueryResponseProvider,
  useQueryResponseData,
} from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { ListViewProvider } from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { StatisticsWidget6, TablesWidget14 } from '../../../../../../_metronic/partials/widgets'
import DatePicker from 'react-datepicker'

export const generateYearOptions = (startYear: any) => {
  const currentYear = new Date().getFullYear()
  const years: any = []

  for (let year = currentYear; year >= startYear; year--) {
    years.push({ value: year.toString(), label: `${year}` })
  }
  return years
}

const UsersList = () => {
  const facilityType = [
    { value: '', label: 'Select one' },
    { value: 'POST_CONSUMER', label: 'PCR' },
    { value: 'POST_INDUSTRIAL', label: 'PIR' },
    { value: 'ISCC', label: 'ISCC' },
    { value: 'OBP', label: 'OBP' },
    { value: 'VERRA', label: 'VERRA' },
  ]
  /* COLLECT PROCESS DISPATCH */

  const searchElements = [
    {
      type: 'select',
      value: 'select',
      options: facilityType,
      name: 'remark',
      label: 'Type',
    },
    {
      type: 'datePicker',
      name: 'start_date',
      label: 'Start date',
    },
    {
      type: 'datePicker',
      name: 'end_date',
      label: 'End date',
    },
  ]
  const initialState = {
    remark: '',
    end_date: '',
    start_date: '',
  }

  const data: any = useQueryResponseData()
  const [searchResult, setSearchResult] = useState(false)
  const [userSelectedData, setUserSelectedData] = useState<any>(initialState)

  const handleChange = (name, value) => {
    setSearchResult(false)
    setUserSelectedData({ ...userSelectedData, [name]: value })
  }
  const { auth }: any = useAuth()

  const { responseData: response } = useFetchCommon({
    api: `franchise/${auth.data.franchiseId}/massBalancer?remark=${userSelectedData.remark
      }&startDate=${new Date(userSelectedData?.start_date)?.toLocaleDateString()}&endDate=${new Date(
        userSelectedData?.end_date
      )?.toLocaleDateString()}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
  })

  console.log({ response }, 'response')

  return (
    <>
      <div className={`grid grid-cols-4 gap-3 my-2`}>
        <div className=''>
          <label className='form-label fs-6 fw-bold'>Special Characteristics</label>
          <select
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #dddddd',
              color: '#000000', // Text color for selected option
            }}
            className='form-select form-select-solid'
            data-kt-select2='true'
            data-placeholder='Select option'
            data-allow-clear='true'
            onChange={(e) => handleChange('remark', e.target.value)}
            value={userSelectedData.remark || ''}
          >
            {facilityType.map((eachOption, eachInd) => (
              <option key={eachInd + 1 + ''} value={eachOption.value}>
                {eachOption.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className='form-label fs-6 fw-bold'>Start date</label>
          <br />
          <DatePicker
            customInput={
              <input
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #dddddd',
                  color: '#000000',
                }}
              />
            }
            placeholderText={`Select Month`}
            className='form-control form-control-solid w-250px ps-14'
            showMonthYearPicker={false}
            showFullMonthYearPicker={false}
            showFourColumnMonthYearPicker
            show
            selected={userSelectedData.start_date || null}
            onChange={(date) => {
              handleChange('start_date', new Date(date).toLocaleDateString('en-US'))
            }}
          />{' '}
          {/* <input
            type='date'
            placeholder='Select Month'
            className='form-control form-control-solid'
            value={userSelectedData.start_date ?
              (() => {
                // Convert MM/DD/YYYY back to YYYY-MM-DD for display
                const dateStr = userSelectedData.start_date;
                if (dateStr instanceof Date) {
                  return dateStr.toISOString().split('T')[0];
                }
                // If it's in MM/DD/YYYY format, convert it
                const parts = dateStr.split('/');
                if (parts.length === 3) {
                  return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                }
                return dateStr;
              })() :
              ''}
            onChange={(e) => {
              handleChange('start_date', new Date(e.target.value).toLocaleDateString('en-US'))
            }}
            style={{ width: '250px', backgroundColor: '#f9f9f9' }}
          /> */}
        </div>
        <div>
          <label className='form-label fs-6 fw-bold'>End date</label>
          <br />
          <DatePicker
            customInput={
              <input
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #dddddd',
                  color: '#000000',
                }}
              />
            }
            placeholderText={`Select Month`}
            className='form-control form-control-solid w-250px ps-14'
            showMonthYearPicker={false}
            showFullMonthYearPicker={false}
            showFourColumnMonthYearPicker
            show
            selected={userSelectedData.end_date || null}
            onChange={(date) => {
              handleChange('end_date', new Date(date).toLocaleDateString('en-US'))
            }}
          />{' '}

          {/* <input
            type='date'
            placeholder='Select Month'
            className='form-control form-control-solid'
            value={userSelectedData.end_date ?
              (() => {
                // Convert MM/DD/YYYY back to YYYY-MM-DD for display
                const dateStr = userSelectedData.end_date;
                if (dateStr instanceof Date) {
                  return dateStr.toISOString().split('T')[0];
                }
                // If it's in MM/DD/YYYY format, convert it
                const parts = dateStr.split('/');
                if (parts.length === 3) {
                  return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                }
                return dateStr;
              })() :
              ''}
            onChange={(e) => {
              handleChange('end_date', new Date(e.target.value).toLocaleDateString('en-US'))
            }}
            style={{ width: '250px', backgroundColor: '#f9f9f9' }}
          /> */}
        </div>
        <div
          className='flex'
          style={{
            marginTop: '27px',
          }}
        >
          <button
            type='button'
            // style={{ backgroundColor: '#ed6e43' }}
            onClick={() => setSearchResult(true)}
            className='btn btn-primary fw-bold px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='filter'
          // disabled={!userSelectedData.date || !userSelectedData.facility}
          >
            Apply
          </button>
          &nbsp;
        </div>
      </div>
      <>



        {/* <div>
          <div className='ml-9 font-bold'>Start Credits</div>
          <TablesWidget14 hideHeader={true} header={header} data={[]} className='mb-5 mb-xl-8' />
        </div> */}


        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#fae8fb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>
                <img src="/media/svg/dashboard/New/recycling capacity.png" alt="" style={{ width: '27px', height: '27px' }}></img>
              </div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Total Purchase (kg)</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {/* {response?.totalCollectionWeigh || ''} */}
                  {(Number(response?.totalCollectionWeigh) || 0).toFixed(2)}
                </div>
              </div>
            </div>
          </div>
          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#fad9cc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>
                <img src="/media/svg/dashboard/New/recycling factory.png" alt="" style={{ width: '27px', height: '27px' }}></img>
              </div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Certified Material (%)</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {response?.certifiedInput != null ? (response.certifiedInput).toFixed(2) : ''}
                </div>
              </div>
            </div>
          </div>
          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#fee9c0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>

                <img src="/media/svg/dashboard/New/waste supplier.png" alt="" style={{ width: '27px', height: '27px' }}></img>

              </div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Conversion Factor</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {response?.conversionFactor != null ? Number(response.conversionFactor).toFixed(2) : ''}
                </div>
              </div>
            </div>
          </div>


          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#f5f3fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>
                <img src="/media/svg/dashboard/New/Facilities.png" alt="" style={{ width: '27px', height: '27px' }}></img>
              </div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Recycling (kg)</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {response?.productionDiversionQty != null ? response.productionDiversionQty.toFixed(2) : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#f5f3fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>
                <img src="/media/svg/dashboard/New/Facilities.png" alt="" style={{ width: '27px', height: '27px' }}></img>
              </div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Certified Product (kg)</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {response?.totalProductionDiversionQty != null ? Number(response.totalProductionDiversionQty).toFixed(2) : ''}
                </div>
              </div>
            </div>
          </div>

          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#fee9c0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>

                <img src="/media/svg/dashboard/New/waste supplier.png" alt="" style={{ width: '27px', height: '27px' }}></img>

              </div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Total Sales (kg)</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {response?.saleOrdersQty != null ? Number(response.saleOrdersQty).toFixed(2) : ''}
                </div>
              </div>
            </div>
          </div>

          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#fad9cc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>
                <img src="/media/svg/dashboard/New/recycling factory.png" alt="" style={{ width: '27px', height: '27px' }}></img>
              </div>

              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Certified Sales (kg)</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {response?.certifiedFinalProduct != null ? Number(response.certifiedFinalProduct).toFixed(2) : ''}
                </div>
              </div>
            </div>
          </div>

          <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start', // ✅ center horizontally
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',        // ✅ center vertically inside this row
              justifyContent: 'center'
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#fae8fb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1a1a1a'
              }}>
                <img src="/media/svg/dashboard/New/recycling capacity.png" alt="" style={{ width: '27px', height: '27px' }}></img>
              </div>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '400' }}>Certified Content (%)</div>
                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                  {response?.certifiedFinalProduct != null && response?.saleOrdersQty != null && Number(response.saleOrdersQty) !== 0
                    ? ((Number(response.certifiedFinalProduct) / Number(response.saleOrdersQty)) * 100).toFixed(2) + '%'
                    : ''}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 
        <div className='row g-3 g-xl-8 mt-2'>
          <div className='col-xl-3'>
            <StatisticsWidget6
              className='card-xl-stretch mb-xl-8'
              color='success'
              title=''
              description='Total Purchase (kg)'
              progress={response?.totalCollectionWeigh || ''}
            />
          </div>

          <div className='col-xl-3'>
            <StatisticsWidget6
              className='card-xl-stretch mb-xl-8'
              color='warning'
              title=''
              description='Certified Material (%)'
              progress={`${response?.certifiedInput * 100 || ''}`}
            />
          </div>
          <div className='col-xl-3'>
            <StatisticsWidget6
              className='card-xl-stretch mb-xl-8'
              color='primary'
              title=''
              description='Conversion Factor'
              progress={response?.conversionFactor || ''}
            />
          </div>

          <div className='col-xl-3'>
            <StatisticsWidget6
              className='card-xl-stretch mb-xl-8'
              color='primary'
              title=''
              description='Certified Product (kg)'
              progress={response?.productionDiversionQty || ''}
            />
          </div>
        </div> */}


        <div>


          <div>
            <div className='form-label fs-6 fw-bold'>Incoming Material</div>
            <TablesWidget14
              hideHeader={true}
              header={header_one}
              data={response.purchaseOrders ?? []}
              className='mb-5 mb-xl-8'
            />
          </div>


          <div className='form-label fs-6 fw-bold'>Recycling</div>
          <TablesWidget14
            hideHeader={true}
            header={header_three}
            data={response.productionOrders ?? []}
            className='mb-5 mb-xl-8'
          />
        </div>

        <div>
          <div className='form-label fs-6 fw-bold'>Outgoing Material</div>
          <TablesWidget14
            hideHeader={true}
            header={header_two}
            data={response.saleOrders ?? []}
            className='mb-5 mb-xl-8'
          />
        </div>
        {/* <div>
          <div className='form-label fs-6 fw-bold'>End Credits</div>
          <TablesWidget14 hideHeader={true} header={header} data={[]} className='mb-5 mb-xl-8' />
        </div> */}
      </>
      <UserEditModal showViewPage getByIdApi='collect/orders/' formName='CollectOrdersModalForm' />
    </>
  )
}

const MassBalancerWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { MassBalancerWrapper }
/* 
'http://localhost:8081/v1/api/franchise/66d5382f62b417173d356f71/massBalancer?startDate=1753868516000&endDate=1753868516000&remark=POST_CONSUMER'
*/
